import { Countries } from '~/common/constants/countries.enum';

export const REFRESH_TOKEN_EXPIRATION_TIME = 30;
export const ACCESS_TOKEN_EXPIRATION_TIME = 30;

export const STATE_PROVINCE_CODES = {
  [Countries.US]: [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
  [Countries.CA]: ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'ON', 'PE', 'QC', 'SK', 'YT'],
};

// eslint-disable-next-line no-restricted-syntax
export enum BRANDS {
  RYP = 'RYP',
  OFP = 'OFP',
  SPLASH = 'SPLASH',
}

export const EO_BRANDS = {
  [BRANDS.RYP]: 'RYP',
  [BRANDS.OFP]: 'OFP',
};

export const BRAND_NAMES = {
  [BRANDS.RYP]: 'RunYourPool',
  [BRANDS.OFP]: 'OfficeFootballPool',
  [BRANDS.SPLASH]: 'Splash',
};

// eslint-disable-next-line no-restricted-syntax
export enum PLATFORMS {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}

export const UNIFIED_LOGIN_ERRORS = [
  'INSUFFICIENT_PASSWORD_RESET_REQUIRED',
  'PASSWORD_MISMATCH_RESET_REQUIRED',
  'PASSWORD_RESET_REQUIRED',
];

export const AUTH_PATHS = [
  '/sign-up',
  '/sign-in',
  '/account/forgot-password',
  '/account/reset-password',
  '/account/confirm-password',
  '/account/reset-password-success',
];

export const APPLICATION_TYPES = {
  RYP: 'runyourpool',
  OFP: 'officefootballpool',
  SPLASH: 'splashsports',
} as const;

export const AUTH_STATUSES = {
  MULTI_FACTOR_REQUIRED: 'MULTI_FACTOR_REQUIRED',
} as const;

export const AUTH_ERRORS = {
  TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',
} as const;

export const EMAIL_OTP_LENGTH = 6;
